"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionVersion = 1;
exports.SessionEventCategory = "Session";
exports.SessionCommandCategory = "Session";
var SessionType;
(function (SessionType) {
    SessionType["Unknown"] = "Unknown";
    SessionType["Video"] = "Video";
    SessionType["Audio"] = "Audio";
    SessionType["RemoteVideoAudioOnly"] = "RemoteVideoAudioOnly";
    SessionType["LocalVideoAudioOnly"] = "LocalVideoAudioOnly";
    SessionType["CreatorVideoOnlyAllAudio"] = "CreatorVideoOnlyAllAudio";
    SessionType["File"] = "File";
    SessionType["SharingScreen"] = "SharingScreen";
    SessionType["VideoLive"] = "VideoLive";
    SessionType["AudioLive"] = "AudioLive";
    SessionType["Data"] = "Data";
})(SessionType = exports.SessionType || (exports.SessionType = {}));
var AttendeeState;
(function (AttendeeState) {
    AttendeeState["Unknown"] = "Unknown";
    AttendeeState["Canceled"] = "Canceled";
    AttendeeState["Rejected"] = "Rejected";
    AttendeeState["Left"] = "Left";
})(AttendeeState = exports.AttendeeState || (exports.AttendeeState = {}));
var Status;
(function (Status) {
    Status["Unknown"] = "Unknown";
    Status["Created"] = "Created";
    Status["Starting"] = "Starting";
    Status["Started"] = "Started";
    Status["Stopped"] = "Stopped";
})(Status = exports.Status || (exports.Status = {}));
//# sourceMappingURL=SessionDefinition.js.map